import { createClient } from '@cloudstudio/editor-sdk/lib';

const cache = {
  rpc: null
}

export async function getRpc() {
  if (cache.rpc) return cache.rpc;
  // 根据相对 Editor 的层级来注册 rpc
  const rpc = await createClient(-1);
  cache.rpc = rpc;
  return rpc;
}
